<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="ibox">
					<div class="ibox-content text-center">
						<div v-if="uploadCandidates.length != 0">
							<h3>Feltöltésre váró fileok:</h3>
							<ul class="list-group mb-5">
								<li class="list-group-item" v-for="file in uploadCandidates" :key="file.id">{{ file.filename
								}}</li>
							</ul>
							<div class="label label-warning h3" v-if="online == false">Internetkapcsolat nélkül nem
								tölthetsz fel fájlokat!</div>
							<button v-else :disabled="uploading == true" @click="uploadList()"
								class="btn btn-lg btn-warning"><i class="fa fa-upload"></i> Feltöltés <i
									v-if="uploading == true" class="fa fa-cog fa-spin"></i></button>
						</div>
						<div v-else>
							<div class="widget p-lg text-center">
								<div class="m-b-md">
									<i class="fa fa-upload fa-4x"></i>
									<h1 class="m-xs"><i class="fa fa-times"></i></h1>
									<h3 class="font-bold no-margins">
										Nincs feltöltésre váró fájl
									</h3>
									<small>Nincs további teendőd!</small>
								</div>
							</div>
							<button class="btn btn-danger btn-lg" :disabled="terminating" @click="terminate">
								<i class="fa fa-cog fa-spin mr-1" v-if="terminating"></i>
								Leadom a készüléket
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import appService from '../../apis/appService.js'
import User from "../../apis/User";
import moment from 'moment'

export default {
	data() {
		return {
			errors: [],
			downloading: false,
			downloaded: false,
			list: [],
			itemName: false,
			notfound: false,
			barcode: '',
			isRunning: false,
			time: 0,
			msg: '',
			uploadCandidates: [],
			uploading: false,
			terminating: false,
		}
	},
	computed: {
		lszsz() {
			return this.$store.state.lszsz;
		},
		online() {
			return this.$store.state.online;
		},
		user() {
			return this.$store.state.user;
		},
	},
	created() {
		this.$store.commit('updateSubTitle', 'Feltöltés/Leadás');
	},
	mounted() {
		this.showUploadList()
	},
	beforeMount() {
		//Create interface between Webview and Native application
		window['tc26'] = {
			components: this,
			finishUpload: () => this.finishUpload(),
		};
	},
	methods: {
		terminate() {
			this.terminating = true;
			clearInterval(window.onlineInterval);
			clearInterval(window.batteryInterval);
			User.logout().then(() => {
				this.$store.commit('updateLszsz', null);
				this.$store.commit('updateUser', null);
				localStorage.removeItem("auth");
				localStorage.removeItem("user");
				appService.terminateApp();
			}).finally(() => {
				this.terminating = false;
			});
		},
		uploadList() {
			this.uploading = true;
				//new Promise(resolve => {
					/*let upload_response =*/ appService.processUploadList(this.user.project_id);
			/*resolve(upload_response);
		}).then(response => {
			console.log('response: '+response);
			this.uploading = false;
			this.showUploadList();
		});*/
		},
		finishUpload() {
			console.log('lefut a finish upload');
			this.uploading = false;
			appService.getTempo(this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
				this.$store.commit('updateUser', { ...this.user, tempo: response.data });
			});
			this.showUploadList();
		},
		showUploadList() {
			this.uploadCandidates = appService.showUploadList(this.user.project_id);
		},
		logger() {
			console.log('barcode list exists a logger fgvben' + this.$root.$data.barcodeListExists);
		},
		dummyBarcode() {
			this.downloaded = false;
			this.downloading = true;
			appService.barcodeDummy();
			let currentdate = moment().format('YYYY-MM-DD HH:mm:ss');
			this.$store.commit('updateLastBarcodeListRefresh', currentdate);
		},
		checkBarcode() {
			//this.list = JSON.parse(localStorage.getItem('barcodelist'));
			/*
			let barcode = this.barcode;

			var found = this.list.filter(function(item){
				return item.barcode === barcode;
			});

			if(found.length > 0){
				this.found_name = found[0].name
			}
			*/
			appService.checkBarcode(this.barcode);
		},
	},
}
</script>

<style></style>